import React from "react";
import { useTranslation } from "react-i18next";

function History() {
  const { t } = useTranslation();
  return (
    <div>
      {/* <div className="row banner" style={{ backgroundImage: 'url(./images/11.jpg)', backgroundSize: 'cover', backgroundPosition: 'center',flexWrap:'nowrap' }}>
        <img src="./images/Pattarath-history.jpeg" alt=""  style={{width:'100%'}} />
      </div> */}
      <img src="./images/Pattarath-history.jpeg" alt=""  style={{width:'100%'}} />
      <div class="container"   >
        <div class="row">
          <div class="col-md-12">
            <div style={{ paddingTop: '0px !important',padding:'60px' }}>
              <h3 className="hheading">{t("temple-history")}</h3>
              <p className="hcontent">
                {t("his-p1")} <br />
                {t("his-p2")}
              </p>
            </div>

          </div>
          {/* <div className="col-md-4 about-frame" >
            <div className="about-right">
              <img src="./images/1.jpeg" style={{ width: '100%' }} alt="About Us" />
              <img src="./images/2.jpeg" style={{ width: '100%' }} alt="About Us" />
              <img src="./images/3.jpeg" style={{ width: '100%' }} alt="About Us" />
            </div>

          </div> */}
        </div>
        
        <div className="row" style={{ padding: '50px', background: 'orange', marginBottom: '50px', borderRadius: '25px' }}>
          <div className="container">
            <h3 className="hheading" style={{ textAlign: 'center' }}>{t("vandanam")}</h3>
            <p className="hcontent" style={{ textAlign: 'center' }}>
              {t("vandanam-lyric")}
            </p>

            <p className="hcontent" style={{ textAlign: 'center', textDecoration: 'underline', lineHeight: '25pt', fontSize: '18pt' }}>
              {t("first-yellow-bottom")}
            </p>

          </div>

        </div>
        <div class="row">
          <div class="col-md-12">
            <div style={{ padding: '60px' }}>
              <p className="hcontent">
                {t("his-p3")}
              </p>
            </div>
          </div>
        </div>
        <div className="row" style={{ padding: '50px', background: 'orange', marginBottom: '50px', borderRadius: '25px' }}>
          <div className="container">

            <p className="hcontent" style={{ textAlign: 'center' }}>
              {t("yellobox-3-1")} <br />
              {t("yellobox-3-2")} <br />
              {t("yellobox-3-3")} <br />
              {t("yellobox-3-4")}
            </p>
            <p className="hcontent">
              {t("his-p5")}

            </p>
          </div>
        </div>
        <div className="row" style={{ padding: '50px', background: 'orange', marginBottom: '50px', borderRadius: '25px' }}>
          <div className="container">

            <p className="hcontent" style={{ textAlign: 'center' }}>
              {t("yb-4-1")} <br />
              {t("yb-4-2")} <br />
              {t("yb-4-3")} <br />
              {t("yb-4-4")} <br />
            </p>
            <p className="hcontent">
              {t("his-p6")}
            </p>
          </div>
        </div>
        <div class="row">
          <div className="container">
            <p className="hcontent">
              {t("his-p7")} <br />
              {t("his-p8")} <br />
              {t("his-p9")}
            </p>
          </div>
        </div>
        <div class="row">
          <div class="col-md-12">
            <div style={{ padding: '60px' }}>

            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default History;
